import { render, staticRenderFns } from "./SolicitacaoDeOrcamentoView.vue?vue&type=template&id=6a60d0dc&scoped=true"
import script from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDeOrcamentoView.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDeOrcamentoView.vue?vue&type=style&index=0&id=6a60d0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60d0dc",
  null
  
)

export default component.exports